import { useSettingsStore } from '~/stores/Settings'
import { useUserStore } from '~/stores/User'

export default defineNuxtPlugin((nuxtApp) => {
  const settingsStore = useSettingsStore()
  const userStore = useUserStore()

  // Run after hydration to avoid rendering client timezone over SSR's UTC markup.
  nuxtApp.hook('app:mounted', () => {
    settingsStore.hydrateFromLocalStorage()
    if (userStore.isAuthenticated) void settingsStore.hydrateFromBackend()
  })

  nuxtApp.hook('auth:login', () => settingsStore.hydrateFromBackend())

  nuxtApp.hook('auth:logout', () => settingsStore.cancelSync())
})
